import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { IdValueObject } from '../../../../utility/model/id-value-object.model';

export class MyKnowledgeId extends IdValueObject {
  static create(value: string): MyKnowledgeId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new MyKnowledgeId(value);
  }
}
